'use client';

import Button from '@enlighten/design-system/dist/Button';
import Grid from '@enlighten/design-system/dist/Grid';
import Typography from '@enlighten/design-system/dist/Typography';
import AddRounded from '@mui/icons-material/AddRounded';
import RemoveRounded from '@mui/icons-material/RemoveRounded';
import { useState } from 'react';

const careers = [
	{
		year: 2026,
		list: ['SK이터닉스와 재생에너지 분야 업무협약 체결', '예비 기술성평가 A등급 획득', '지붕형 태양광 설비 투자유치 300억 원', 'ISO 9001·14001 국제표준 인증 획득'],
	},
	{
		year: 2025,
		list: ['삼성전자 협력사 RE100 자가용 태양광 공급사업자 선정', 'KT&G 5MW 규모 PPA 체결', '충청남도 산업단지 RE100 추진 업무 협약 체결'],
	},
	{
		year: 2024,
		list: ['국내 최대 규모 ‘RE100 구독형 태양광’ 준공 (단일 규모 3 MW, 당시 기준)', '‘경기 RE100 거래 플랫폼 구축’ 업무 협약 체결'],
	},
	{
		year: 2023,
		list: [
			'경기도 산업단지 RE100 투자 협약 체결',
			'엔라이튼 - 네이버 제 2 사옥 전력 공급 시작',
			'롯데글로벌로지스 7.6MW 통합서비스 제공',
			'“태양광 발전 이상 탐지 방법 및 장치“ 특허 취득',
			'“태양광 발전소 이상 탐지를 위한 데이터 전처리 방법 및 장치“ 특허 취득',
		],
	},
	{
		year: 2022,
		list: [
			'‘발전왕’ 발전소 등록용량 4GW 돌파(M/S 20%)',
			'산업통상자원부 “2022 한국에너지대상” 장관 표창 수상',
			'네이버와 제3자간 전력거래계약체결(PPA)',
			'과학기술정보통신부 “2022 디지털 이노베이션” IT 플랫폼 부문 장관 표창 수상',
			'국제연합 및 유엔에너지 주관 국내 최초 CF100(24/7 Carbon Free Energy) 파트너사 등록 (국내유일 RE100&CF100 동시 파트너사 등극)',
			'산업통상자원부 ‘전기자동차충전사업자‘ 등록',
			'“태양광 발전량 예측 시스템(Photovoltaic Generation Forecasting System)“ 특허 취득',
			'솔라브리지, 금융위원회 “온라인투자연계금융업자” 등록',
			'엔라이튼으로 사명 변경',
		],
	},
	{
		year: 2021,
		list: [
			'ICT InnoFesta 2021 과학기술정보통신부 장관 표창',
			'‘발전왕’ 태양광 발전소 시장점유율 10% 돌파',
			'국내 1호 산업통상자원부 ‘재생에너지 전기공급사업자’ 등록',
			'‘발전소 군집화 및 군집 기반의 이상진단 방법’ 특허 취득',
			'‘발전왕’ 발전소 등록용량 1GW 돌파!',
			'국내 최초 지붕 태양광 전문 펀드 참여',
			'SK 건설과 ‘RE100 및 신재생에너지 발전사업 추진을 위한 업무협약’ 체결',
			'시리즈 C 투자 유치',
			'전력거래소 재생에너지 발전량 예측제도 실증사업 공식 합격',
		],
	},
	{
		year: 2020,
		list: [
			'국내 최초 RE100 이행 계약 체결',
			'국내 최초 CDP(탄소정보공개프로젝트) 인증 재생에너지 프로바이더 인증 획득',
			'산업통상자원부 ‘전력데이터 신서비스 개발’ 대상 · 장관상 수상',
			'과학기술정보통신부 ‘글로벌 ICT 미래 유니콘’ 선정',
			'한국수력원자력 ‘소규모 태양광 통합발전소(VPP) 업무 협약’ 체결',
			'영국 정부 ‘2020 한-영 테크 로켓쉽 어워드’ 우승',
		],
	},
	{
		year: 2019,
		list: [
			'시리즈B 투자 유치',
			'한국에너지공단 ‘태양광 대여사업자’ 선정',
			'전력거래소 ‘소규모 전력중개사업자’ 등록',
			'산업통상자원부 ‘전기신사업자’ 등록',
			'IMM인베스트먼트 ‘국내 최대 소규모 태양광 발전사업 공동사업’',
		],
	},
	{
		year: 2018,
		list: ['전력 IT 솔루션 개발 운영 전문기업 ‘STRIX’ 인수', '시리즈 A 투자 유치', '태양광 연계 ESS 금융 약정 실적 1,000억 원 달성'],
	},
	{
		year: 2017,
		list: ['한국전력공사가 지정한 ‘제1차 에너지 스타트업’ 선정'],
	},
	{
		year: 2016,
		list: ['솔라커넥트 법인 설립'],
	},
];

export default function Section6() {
	const [more, setMore] = useState<boolean>(false);

	return (
		<Grid container direction="column" alignItems="center" padding={{ xs: '60px 24px', md: '162px 24px 160px' }}>
			<Typography display={{ xs: 'none', md: 'block' }} fontSize={{ xs: 24, md: 40 }} fontWeight={700} textAlign="center" lineHeight={1.35} color="common.white" marginBottom={{ xs: 0, md: 10 }}>
				{'엔라이튼은 오늘도\n에너지 시장을 혁신하고 있습니다.'}
			</Typography>
			<Typography display={{ xs: 'block', md: 'none' }} fontSize={{ xs: 24, md: 40 }} fontWeight={700} textAlign="center" lineHeight={1.35} color="common.white" marginBottom={{ xs: 0, md: 10 }}>
				{'엔라이튼은 오늘도\n에너지 시장을 혁신하고\n있습니다.'}
			</Typography>
			<Grid container direction="column" gap={{ xs: '50px', md: '60px' }} maxWidth={720} marginBottom={{ xs: '30px', md: '60px' }}>
				{careers
					.sort((a, b) => b.year - a.year)
					.slice(0, more ? careers.length : 4)
					.map(({ year, list }, i) => (
						<Grid key={i} container direction={{ xs: 'column', md: 'row' }}>
							<Typography fontSize={22} fontWeight={700} color="#7F3FFF" width={120} paddingTop="20px" paddingBottom="10px">
								{year}
							</Typography>
							<Grid container direction="column" gap={{ xs: '12px', md: '15px' }} flex={1}>
								{list.map((content, j) => (
									<Grid key={j} border="1px solid #36383A" borderRadius={1} padding={{ xs: '20px 30px', md: '20px 15px' }}>
										<Typography fontSize={18} lineHeight={1.5} color="common.white">
											{content}
										</Typography>
									</Grid>
								))}
							</Grid>
						</Grid>
					))}
			</Grid>
			<Button
				onClick={() => {
					setMore((state) => !state);
				}}
				sx={{
					height: { xs: 44, md: 52 },
					padding: { xs: '9px 15px', md: '6px 23px' },
				}}
			>
				{more ? (
					<>
						<RemoveRounded fontSize="small" sx={{ marginRight: 1 }} />
						접기
					</>
				) : (
					<>
						<AddRounded fontSize="small" sx={{ marginRight: 1 }} />
						더보기
					</>
				)}
			</Button>
		</Grid>
	);
}
